import { Loader, Flex } from '@mantine/core';
import type { ReactNode } from 'react';

interface WithFallbackProps<T> {
  data: T | null | undefined;
  isLoading?: boolean;
  children: (data: T) => ReactNode;
  LoadingComponent?: ReactNode;
  FallbackComponent?: ReactNode;
}

const DefaultLoading = () => (
  <Flex w='100%' justify='center' align='center' flex={1}>
    <Loader />
  </Flex>
);

export const WithFallback = <T,>({
  data,
  isLoading,
  children,
  LoadingComponent = <DefaultLoading />,
  FallbackComponent = null,
}: WithFallbackProps<T>) => {
  if (isLoading) {
    return <>{LoadingComponent}</>;
  }

  if (!data) {
    return <>{FallbackComponent}</>;
  }

  return <>{children(data)}</>;
};
